import {React,useState,useEffect} from "react";
import  Link  from "react-router-dom";
import axios from "axios";
import configData from "../config.json";
import  {useNavigate}  from "react-router-dom";

const Login = () => {

  const [inputData,setInputData]=useState({email:'',passcode:''});
  const navigate=useNavigate();

    useEffect(() => { 
        localStorage.removeItem('regEmail');
    }, []);

  const handleInput=(e)=>{
    const {name,value}=e.target; 
    setInputData({...inputData,[name]:value});    
  }

  const handleSubmit=async(e)=>{
    e.preventDefault();
    const allinputData={email:inputData.email, passcode:inputData.passcode}
    let res=await axios.post(configData.SERVER_URL+'/AcrloginEntry',allinputData);
    if(res.status===200){
      if(res.data[0].acount===1){
        localStorage.setItem('regEmail', res.data[0].regEmail);
        window.location.replace('/acr');
      } 
      else{
        alert('Invalid Email ID or password')
      }
    } 
    else{
      alert('System Error');
    } 
  }

  const handleSubmitPost=async(e)=>{
    e.preventDefault();
    const allinputData={email:inputData.email, passcode:inputData.passcode}
    let res=await axios.post(configData.SERVER_URL+'/AcrloginPost',allinputData);
    if(res.status===200){
      if(res.data.acount===2){
        alert('Successfully Registered');
        window.location.replace('/acr');
      } 
      else{
        alert('Already Exist')
      }
    } 
    else{
      alert('System Error');
    } 
  }

  return (
    <>
      <div className="container my-3 py-3">
        <h1 className="text-center">ACR Tracking System</h1>
        
        <div class="row my-4 h-100">
          
          <div className="col-md-4 col-lg-4 col-sm-8 mx-auto">
            <hr />
            <form onSubmit={handleSubmit}>
                <div class="my-3">
                <label for="display-4">NID</label>
                <input
                  type="text"
                  class="form-control"
                  id="email"
                  name="email"
                  // placeholder="name@example.com"
                  value={inputData.email}
                  onChange={(e)=>{handleInput(e)}}
                />
                </div>

                
              <div class="my-3">
                <label for="floatingPassword display-4">Password</label>
                <input
                  type="password"
                  class="form-control"
                  id="passcode"
                  name="passcode"
                  placeholder="Password"
                  value={inputData.passcode}
                  onChange={(e)=>{handleInput(e)}}
                />
              </div>
              <div className="text-center">
                <button class="my-2 mx-auto btn btn-dark" type="submit">
                  Login
                </button>
              </div>
            </form>
            <hr/>
            <div class="my-3">
              <div className="text-center">
                <button class="my-2 mx-auto btn btn-info" onClick={(e)=>{handleSubmitPost(e)}}>
                  Register
                </button>
              </div>
            </div>
          </div>
          
        </div>
        
      </div>
    </>
  );
};

export default Login;
